/*
 * Created on Tue Apr 01 2025
 *
 *  Copyright (c) Kayool Technologies PVT LTD, Inc - All Rights Reserved 2025 Jagan
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential Written by Jagan <jagancpj246@gmail.com>, 2025.
 */


import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-fixed-call',
  templateUrl: './fixed-call.component.html',
  styleUrls: ['./fixed-call.component.scss'],
  standalone: true,
  imports: [],
})
export class FixedCallComponent {
  iconColor: string = '#0790df';

  constructor(private analyticsService: AnalyticsService) {}

  onChatButtonClicked(event: any): void {
    const button = event.target as HTMLButtonElement;
    button.blur(); // Removes focus/hover effect

    this.analyticsService.trackEvent('chat_call_click', {
      event_category: 'Button',
      event_label: 'Start chat/call button click',
    });
  }
}
